import React from 'react'
import PropTypes from 'prop-types'
import { Formik } from 'formik'
import * as Yup from 'yup'
import styled from 'styled-components'
import _ from 'lodash'
import axios from 'axios'
import { useToasts } from 'react-toast-notifications'

import {
  Modal,
  ModalFooter,
  ModalColumns,
  Button,
  PaddedDivider,
} from '../../../ui'
import {
  FormikSelect,
  Form,
  FormikFileInput,
  Error,
  FormikEditor,
} from '../../../form'
import { jsonToFormData, handleBackEndErrors } from '../../../../utilities'

const WideFormikEditor = styled(FormikEditor)`
  ${p => p.theme.layout.tablet} {
    grid-column: 1/3;
  }
`

const NoteModal = ({
  isVisible,
  note,
  setModalVisibility,
  client,
  setNoteToEdit,
  user,
  submitResponse,
}) => {
  const newNote = _.isEmpty(note)
  const { addToast } = useToasts()
  const [backEndErrors, setBackEndErrors] = React.useState({})

  const onSubmit = async (values, { setSubmitting }) => {
    const newValues = jsonToFormData(values)
    axios({
      method: 'post',
      url: newNote ? 'v1/clients/notes/create' : 'v1/clients/notes/update',
      data: newValues,
    })
      .then(response => {
        submitResponse(response.data, newNote ? 'add' : 'edit')
        addToast(`Note ${newNote ? 'created' : 'updated'} successfully`, {
          appearance: 'success',
        })
        setModalVisibility(false)
        setNoteToEdit({})
      })
      .catch(error => {
        if (error.response.status === 422) {
          setBackEndErrors(error.response.data.errors)
        } else {
          setBackEndErrors(error.response.data.error)
          addToast(
            `Error ${newNote ? 'creating' : 'updating'} note, please try again`,
            {
              appearance: 'error',
            },
          )
        }
      })

    setSubmitting(false)
  }

  const onClose = () => {
    setNoteToEdit({})
    setModalVisibility(false)
  }

  return (
    <Modal
      isVisible={isVisible}
      heading={newNote ? 'Create New Note' : 'Update Note'}
      onClose={onClose}
    >
      <Formik
        initialValues={{
          client_id: client ? client : '',
          user_id: user ? user : '',
          note_id: note && note.id ? note.id : '',
          marked_as: note && note.marked_as ? note.marked_as : '',
          type: note && note.type ? note.type : '',
          note: note && note.note ? note.note : '',
          file: note && note.file ? note.file : null,
        }}
        validationSchema={Yup.object().shape({
          marked_as: Yup.string(),
          type: Yup.string().required('Required'),
          note: Yup.string().required('Required'),
          file: Yup.mixed(),
        })}
        onSubmit={onSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <ModalColumns>
              <div>
                {/* Removed 15/06/2020 */}
                {/* <FormikSelect
                  name="marked_as"
                  label="Mark note as"
                  placeholder="Please select..."
                  options={[
                    {
                      value: 'Urgent',
                      label: 'Urgent',
                    },
                    {
                      value: 'Not Urgent',
                      label: 'Not Urgent',
                    },
                  ]}
                /> */}
                <FormikSelect
                  name="type"
                  label="Note type"
                  placeholder="Please select..."
                  options={[
                    {
                      value: 'Sales Call (Qualified)',
                      label: 'Sales Call (Qualified)',
                    },
                    {
                      value: 'Sales Call (Unqualified)',
                      label: 'Sales Call (Unqualified)',
                    },
                    {
                      value: 'Service Call',
                      label: 'Service Call',
                    },
                    {
                      value: 'Sales Meeting',
                      label: 'Sales Meeting',
                    },
                    {
                      value: 'Service Meeting',
                      label: 'Service Meeting',
                    },
                    {
                      value: 'Email Incoming',
                      label: 'Email Incoming',
                    },
                    {
                      value: 'Email Outgoing',
                      label: 'Email Outgoing',
                    },
                    {
                      value: 'E-Shot',
                      label: 'E-Shot',
                    },
                    {
                      value: 'General Note',
                      label: 'General Note',
                    },
                    {
                      value: 'Interview',
                      label: 'Interview',
                    },
                    {
                      value: 'SMS',
                      label: 'SMS',
                    },
                    {
                      value: 'LinkedIn Message',
                      label: 'LinkedIn Message',
                    },
                    {
                      value: 'Door Knock',
                      label: 'Door Knock',
                    },
                    {
                      value: 'Networking Events',
                      label: 'Networking Events',
                    },
                  ]}
                />
              </div>
              <FormikFileInput label="Attach a file" name="file" />
              <WideFormikEditor name="note" label="Description" />
            </ModalColumns>
            {_.isEmpty(backEndErrors) ? (
              ''
            ) : (
              <>
                <PaddedDivider />
                <Error>{handleBackEndErrors(backEndErrors)}</Error>
              </>
            )}
            <ModalFooter>
              <Button type="submit" disabled={isSubmitting}>
                {newNote ? 'Save' : 'Save changes'}
              </Button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

NoteModal.defaultProps = {
  note: {},
  client: null,
  user: null,
}

NoteModal.propTypes = {
  note: PropTypes.object,
  setNoteToEdit: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  setModalVisibility: PropTypes.func.isRequired,
  client: PropTypes.string,
  user: PropTypes.number,
  submitResponse: PropTypes.func.isRequired,
}

export default NoteModal
